import React from 'react';
import './ProcessMeta.css';
import Tooltip from '../tooltip/Tooltip';
import { ParticipantGroupChip } from '../participant-group/ParticipantGroupChips';
import { colorVar, compareParticipantGroups } from '../../util/participantGroups';
import { processLocationName, releaseLabel, releaseTargetGroupIds, ruleBadges } from './processUtils';

/**
 * Header of a process: template chip, location chip, rule chips and the groups its release steps release
 * ("Freigabe für") — replaces the former kind chips (Öffentlich/Privat, "Member eingeladen").
 */
function ProcessMeta({ process, template, groupsById }) {
  const badges = ruleBadges(process);
  const releaseGroups = [...releaseTargetGroupIds(process)]
    .map(id => groupsById.get(id))
    .filter(Boolean)
    .sort(compareParticipantGroups);
  const templateName = process.processTemplateName || template?.name || 'Prozess';
  const locationName = processLocationName(process);

  return (
    <div className={'processMeta'}>
      <div className={'processMetaRow'}>
        <Tooltip text={template?.description || 'Vorlage dieses Prozesses'}>
          <span
            className={'processTemplateChip'}
            style={{ '--process-template-color': colorVar(template?.colorKey ?? 'accent') }}
          >
            <span className={'material-symbols-rounded processTemplateChipIcon'} aria-hidden={'true'}>
              {template?.icon || 'checklist'}
            </span>
            {templateName}
          </span>
        </Tooltip>
        {/* One location per process: every event takes it, mails use its textblock variants, flat rates and
            deductions its catalog amounts. */}
        <Tooltip text={'Ort aller Events dieses Prozesses – Mails nutzen die Textbaustein-Varianten dieses Orts, Pauschalen & Abzüge seine Katalogbeträge'}>
          <span className={'processLocationChip'}>
            <span className={'material-symbols-rounded processLocationChipIcon'} aria-hidden={'true'}>location_on</span>
            <span className={'processLocationChipName'}>{locationName}</span>
          </span>
        </Tooltip>
        {badges.map(b => (
          <Tooltip key={b.key} text={b.hint}>
            <span className={'processRuleChip'}>
              <span className={'material-symbols-rounded processRuleChipIcon'} aria-hidden={'true'}>{b.icon}</span>
              {b.label}
            </span>
          </Tooltip>
        ))}
      </div>
      {releaseGroups.length > 0 && (
        <div className={'processMetaRow'}>
          <span className={'processMetaLabel'}>Freigabe für</span>
          {releaseGroups.map(g => (
            <ParticipantGroupChip key={g.id} group={g} label={releaseLabel(g)} />
          ))}
        </div>
      )}
    </div>
  );
}

export default ProcessMeta;
